import * as React from 'react';

/**
 * Injects additional css classnames into the existing prop `classNames` which was
 * added by ui-engine by convention.
 *
 * Injected class must be defined **globally**.
 *
 * Global css classes should be the correct usage, to use for e.g modes, or sizing
 */
export const withClassNames = (additionalClasses: string, onlyWhenNested?:boolean) =>
<P extends object>(
  WrappedComponent: (React.ComponentClass<P> | React.FC<P>),
  uiEngineProps
): React.FC<P & { className: string }> => (props:any) => {

  const addClasses = !onlyWhenNested || (uiEngineProps.resolveContext && uiEngineProps.resolveContext.path.length > 1);
  const className = addClasses ? `${props.className} ${additionalClasses}` : props.className;

  return <WrappedComponent {...props} className={className}/>;
};
